const API_URL = (process.env.REACT_APP_API_URL || '') + '/api';

/**
 * Helper to call the unified AI endpoint.
 * @param {string} action The AI feature to use (e.g., 'generateJobDescription')
 * @param {object} payload The payload expected by the specific AI action
 * @returns {Promise<any>} The AI result
 */
export const callAI = async (action, payload) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${API_URL}/ai/action`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ action, payload }),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to communicate with AI Service');
    }
    
    return data.data;
  } catch (error) {
    console.error(`AI API Error [${action}]:`, error);
    throw error;
  }
};
